// extracted by mini-css-extract-plugin
export default {"log-in-button":"GoogleOauthButton_log-in-button__0O4hC","google-icon":"GoogleOauthButton_google-icon__Am7VO"};